export default function VippsAuthenticate({vippsAuthenticate}: {vippsAuthenticate: boolean}) {
    

    if (vippsAuthenticate) {
        return (
            <section className="px-4 py-10 flex flex-col items-center justify-center text-center">
                <img
                    src="https://chamcore.com/chameleon/uploads/templates/vipps_icon.png" // 🔥 replace with your Vipps logo path
                    alt="Vipps"
                    className="w-32 h-auto mb-6"
                />
                <h3 className="text-2xl font-bold text-purple-900 mb-2">
                    {"Åpne Vipps for å bekrefte betalingen"}
                </h3>
                <p className="text-gray-600 mb-6 max-w-sm">
                    {"Vi har sendt en forespørsel til Vipps. Vennligst åpne appen og bekreft for å fortsette."}
                </p>
                <div className="animate-pulse text-purple-600 font-medium">
                    {"Venter på bekreftelse…"}
                </div>
            </section>
        )
    }
}